(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nbp-lp-content-expanded"]) return;
  try {
    
document.addEventListener('click', function(event) {
  var trigger = event.target.closest('[data-nbp-purchase-scroll]');
  if (!trigger) return;

  var target = document.getElementById('nbp-product-cart') ||
    document.querySelector('[data-type="add-to-cart-form"]') ||
    document.querySelector('.product-page-info__button-add-to-cart');

  if (!target) return;
  event.preventDefault();
  target.scrollIntoView({ behavior: 'smooth', block: 'center' });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pino-ouchi-blog-article"]) return;
  try {
    
(() => { if (!document.getElementById('PinoOuchiArticle')) return;
(() => {
  'use strict';
  const bootstrap = window.pinoQuiz;
  const root = document.documentElement;
  const unlock = () => {
    root.classList.remove('quiz-pending');
    document.querySelectorAll('[data-quiz-gate]').forEach(el => { el.hidden = false; });
    window.dispatchEvent(new Event('resize'));
  };
  const failOpen = () => {
    if (bootstrap) { bootstrap.failed = true; bootstrap.failOpen(); }
    else unlock();
  };
  const initializeQuiz = () => {
    const buttons = [...document.querySelectorAll('button[data-answer]')];
    const result = document.getElementById('quiz-result');
    const label = document.getElementById('result-label');
    const gate = document.getElementById('quiz-gate');
    if (!bootstrap || bootstrap.failed || buttons.length !== 4 || !result || !label || !gate) {
      failOpen();
      return;
    }
    let answered = false;
    buttons.forEach(button => {
      button.addEventListener('click', () => {
        if (answered) return;
        try {
          answered = true;
          const correct = button.dataset.answer === '5';
          buttons.forEach(option => {
            option.disabled = true;
            option.classList.toggle('is-selected', option === button);
            option.classList.toggle('is-correct', option.dataset.answer === '5');
            option.setAttribute('aria-expanded', 'true');
            option.setAttribute('aria-pressed', String(option === button));
          });
          result.hidden = false;
          label.textContent = correct ? '正解です。答えは、約5％。' : '惜しいです。答えは、約5％。';
          unlock();
          label.focus({ preventScroll: true });
          result.scrollIntoView({ behavior: 'auto', block: 'nearest' });
        } catch { failOpen(); }
      });
    });
    result.hidden = true;
    bootstrap.ready = true;
    window.clearTimeout(bootstrap.timer);
  };
  try { initializeQuiz(); } catch { failOpen(); }

  const continueLink = document.querySelector('.continue-link');
  continueLink?.addEventListener('click', () => {
    document.getElementById('birth-date')?.focus({ preventScroll: true });
  });
  document.querySelector('a[href="#source-birth"]')?.addEventListener('click', () => {
    const details = document.querySelector('.sources details');
    if (details) details.open = true;
  });

  const allowed = new Set(['utm_source','utm_medium','utm_campaign','utm_content','utm_term','utm_id','fbclid','gclid','yclid','msclkid']);
  const destination = new URL('https://pinostudio-photo.jp/pages/ouchi-photo-studio-lp');
  new URLSearchParams(window.location.search).forEach((value, key) => {
    if (allowed.has(key) && value.length > 0 && value.length <= 200 && !/[\u0000-\u001f\u007f]/u.test(value)) {
      destination.searchParams.set(key, value);
    }
  });
  document.querySelectorAll('[data-product-cta]').forEach(link => { link.href = destination.href; });

  const jst = new Date(Date.now() + 9 * 60 * 60 * 1000);
  const year = jst.getUTCFullYear();
  const month = String(jst.getUTCMonth() + 1).padStart(2, '0');
  document.querySelectorAll('time[data-article-updated]').forEach(time => {
    time.dateTime = `${year}-${month}-01`;
    time.textContent = `${year}.${month}.01 更新`;
  });
  const progress = document.querySelector('.reading-progress span');
  let scheduled = false;
  const update = () => {
    const height = root.scrollHeight - window.innerHeight;
    const ratio = root.classList.contains('quiz-pending') || height <= 0 ? 0 : Math.min(1, Math.max(0, window.scrollY / height));
    if (progress) progress.style.width = `${ratio * 100}%`;
    scheduled = false;
  };
  const schedule = () => { if (!scheduled) { scheduled = true; window.requestAnimationFrame(update); } };
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  update();
})();

(() => {
  'use strict';
  document.querySelectorAll('[data-gallery-shell]').forEach(shell => {
    const track = shell.querySelector('[data-gallery]');
    const slides = track ? [...track.querySelectorAll('.voice-photo')] : [];
    const controls = shell.querySelector('.gallery-controls');
    const previous = shell.querySelector('[data-gallery-prev]');
    const next = shell.querySelector('[data-gallery-next]');
    const status = shell.querySelector('[data-gallery-status]');
    if (!track || !slides.length || !controls || !previous || !next || !status) return;

    const positions = () => {
      const left = track.getBoundingClientRect().left;
      return slides.map(slide => slide.getBoundingClientRect().left - left + track.scrollLeft);
    };
    const update = () => {
      const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
      const atEnd = track.scrollLeft >= maximum - 1;
      const points = positions();
      const first = points.findIndex(point => point >= track.scrollLeft - 2);
      const index = atEnd ? slides.length - 1 : Math.max(0, first);
      status.textContent = `${index + 1} / ${slides.length}`;
      previous.setAttribute('aria-disabled', String(track.scrollLeft <= 1));
      next.setAttribute('aria-disabled', String(atEnd));
    };
    const move = direction => {
      const points = positions();
      const current = track.scrollLeft;
      const destination = direction > 0
        ? points.find(point => point > current + 2) ?? track.scrollWidth
        : [...points].reverse().find(point => point < current - 2) ?? 0;
      track.scrollTo({ left: destination, behavior: 'auto' });
      update();
    };
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('keydown', event => {
      if (event.target !== track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      if (event.key === 'Home' || event.key === 'End') {
        track.scrollTo({ left: event.key === 'Home' ? 0 : track.scrollWidth, behavior: 'auto' });
        update();
      } else move(event.key === 'ArrowRight' ? 1 : -1);
    });
    let scheduled = false;
    track.addEventListener('scroll', () => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(() => { update(); scheduled = false; });
    }, { passive: true });
    window.addEventListener('resize', update);
    controls.hidden = false;
    update();
  });
})();

})();

  } catch(e) { console.error(e); }
})();
})();
